import type { ComponentProps } from 'react';

function ScratchcardStar({ className, ...props }: ComponentProps<'svg'>) {
  return (
    <svg className={className} {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 112 84" fill="none">
      <g opacity="0.1" clipPath="url(#clip0_6212_4019)">
        <path
          d="M98.5812 24.6156C106.662 30.9949 116.816 35.1691 126.494 38.2572C136.751 41.5285 147.066 43.9109 157.23 48.2325C162.179 50.3347 167.823 53.6625 169.147 57.5609C172.945 68.7498 131.687 64.9996 124.77 69.6631C110.166 79.512 127.787 106.988 131.647 124.345C132.41 127.764 132.722 131.824 128.97 132.348C125.563 132.827 121.094 130.013 117.508 127.477C102.218 116.659 98.4833 96.0022 83.2405 85.1297C81.2844 83.7345 79.2463 82.2933 77.0297 81.4664C74.1895 80.4086 71.5098 80.5106 68.9916 80.6433C54.2179 81.4106 27.8976 92.0008 13.124 92.768C9.13422 92.9732 4.11139 92.8154 0.420469 89.7622C-3.50315 86.5127 -2.9904 82.4581 -2.04551 79.3887C0.429495 71.3476 11.9166 53.9618 14.3916 45.9207C15.4615 42.436 16.5425 38.8812 15.8921 34.7888C13.8793 22.0132 -24.7568 7.57678 -36.7048 -4.79216C-41.3771 -9.63051 -38.7403 -14.5089 -32.2457 -13.0483C-13.7146 -8.88088 13.9603 3.03345 29.6657 -1.14344C43.4612 -4.81256 50.7084 -21.6102 58.6871 -30.5051C61.6184 -33.7774 70.0119 -31.014 72.8802 -25.832C81.9369 -9.48627 78.7352 7.7978 97.1486 23.4386C97.6186 23.8394 98.0953 24.2277 98.5834 24.6114L98.5812 24.6156Z"
          className="fill-background-secondary"
        />
      </g>
      <defs>
        <clipPath id="clip0_6212_4019">
          <rect width="221.428" height="140.424" fill="white" transform="translate(116.724 158.175) rotate(-150)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export { ScratchcardStar };
